import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog_Confirmation } from '@app/styles';
import { ComponentSync } from '@nu-art/thunderstorm-frontend';
import { flatArray, removeItemFromArray, StaticLogger } from '@nu-art/ts-common';
import { ModuleFE_Pathway, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../../../../_entity.js';
import { Renderer_Transition } from '../../../../Page_PathwayEditor/renderers/Renderer_Transition.js';
import { Renderer_PathwayItemChildSelector } from '../../../../Page_PathwayEditor/renderers/Renderer_PathwayItemChildSelector.js';
export class Dialog_DeletePathwayState extends ComponentSync {
    static show = (sProps) => {
        const state = ModuleFE_PathwayState.cache.unique(sProps.stateId);
        if (!state)
            return;
        const props = { pathwayIds: [sProps.pathwayId], state };
        Dialog_Confirmation.show({
            header: 'Delete State?',
            content: () => _jsx(Dialog_DeletePathwayState, { ...props }),
            buttons: [
                {
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => {
                        try {
                            await ModuleFE_PathwayState._v1.deletePathwayState({
                                pathwayStates: [state],
                                pathwayIds: props.pathwayIds
                            }).executeSync();
                            sProps.onDeleteCB?.();
                        }
                        catch (err) {
                            StaticLogger.logError('Dialog_DeletePathwayState', 'Failed deleting pathway state', err);
                        }
                    }
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: () => {
                    }
                }
            ]
        });
    };
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.state = nextProps.state;
        state.pathway = ModuleFE_Pathway.cache.unique(nextProps.pathwayIds[0]);
        state.transitions = ModuleFE_PathwayTransition.cache.filter(t => t.sourceId === state.state._id || t.targetId === state.state._id);
        state.childPathwayIds = this.inferRecursiveChildPathwayIds(state.pathway._id);
        return state;
    }
    // ######################## Logic ########################
    inferRecursiveChildPathwayIds(parentPathwayId) {
        const directChildren = ModuleFE_Pathway.getChildren(parentPathwayId);
        return flatArray(directChildren.map(child => {
            return [
                child._id,
                ...this.inferRecursiveChildPathwayIds(child._id),
            ];
        }));
    }
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete the state" }), _jsx("div", { children: this.state.state.name }), this.renderSection_Transitions(), _jsxs("div", { children: ["Are you sure you want to delete this state", this.state.transitions.length ? ' and its transitions' : '', "?"] }), this.render_PathwaySelection()] });
    }
    renderSection_Transitions = () => {
        if (!this.state.transitions.length)
            return;
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "By deleting this state, the following transitions will also be deleted" }), this.state.transitions.map(transition => _jsx(Renderer_Transition, { transition: transition }, transition._id))] });
    };
    render_PathwaySelection = () => {
        return _jsx(Renderer_PathwayItemChildSelector, { pathwayId: this.state.pathway._id, childFilter: child => this.state.childPathwayIds.includes(child._id), onChangeCallback: (newPathwayIds) => {
                //Remove all ids that are in the original but not in new
                this.props.pathwayIds.forEach(id => {
                    if (!newPathwayIds.includes(id))
                        removeItemFromArray(this.props.pathwayIds, id);
                });
                //Add new ids to original
                newPathwayIds.forEach(id => {
                    if (!this.props.pathwayIds.includes(id))
                        this.props.pathwayIds.push(id);
                });
            } });
    };
}
//# sourceMappingURL=Dialog_DeletePathwayState.js.map